import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchContainerSeries } from '../../redux/thunks/series.js'
import ItemCard from '../ItemCard/ItemCard.js';
import Loading from '../Loading/Loading.js';

const ContainerSeries = (props) => {

    const { categories, input } = props
    const container = useSelector(state => state.containerSeries.data)
    const dispatch = useDispatch()
    const limit = useSelector(state => state.containerSeries.limit)
    const page = useSelector(state => state.containerSeries.page)
    const status = useSelector(state => state.containerSeries.status)

    useEffect(() => {
        dispatch(fetchContainerSeries({ categories, input, limit, page }))
    }, [categories, dispatch, input, limit, page])

    return (
        <div className='fl-cl moviesSeries__container' >
            <h2>SERIES</h2>
            {
                status === 'loading'
                    ? <Loading />
                    : !container.length
                        ? <h3>No se encontraron resultados</h3>
                        : !!container.length &&
                        <div className='moviesSeries__div'>
                            {
                                container.map(i => (
                                    <ItemCard
                                        actors={i.actors}
                                        description={i.description}
                                        director={i.director}
                                        category={i.category}
                                        key={i._id}
                                        img={i.link_img}
                                        season={i.season}
                                        title={i.title}
                                        trailer={i.link_trailer}
                                    ></ItemCard>)
                                )}
                        </div>
            }
        </div>
    )
}

export default ContainerSeries